import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { organizationService } from "./organization.service";
import { TOrganization } from "~/types/user";

const orgKeys = {
  all: ["organizations"] as const,
  detail: (id: string) => ["organizations", id] as const,
};

export const useOrganizations = () =>
  useQuery({
    queryKey: orgKeys.all,
    queryFn: organizationService.getAll,
  });

export const useOrganization = (id: string) =>
  useQuery({
    queryKey: orgKeys.detail(id),
    queryFn: () => organizationService.getOne(id),
    enabled: !!id,
  });

export const useUpdateOrganization = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }: { id: string; body: Partial<TOrganization> }) =>
      organizationService.update(id, body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: orgKeys.all });
    },
  });
};
